import React from 'react';
import { Button } from 'antd';
import Card from '../../../../../../components/Card/Card';

export default function IndustryHandoutCard({
  accentColor,
  industryOptions,
  selectedIndustryId,
  selectedIndustry,
  handoutPdf,
  onSelectIndustry,
}) {
  if (!industryOptions?.length) return null;

  return (
    <Card
      className="testing-exercising-card"
      color={accentColor}
      title="See it in your industry"
      description="Select a sector to preview the impact statement, then download the matching handout."
    >
      <div className="testing-exercising-card-body testing-exercising-industry">
        <div className="testing-exercising-industry__chips" role="tablist" aria-label="Industries">
          {industryOptions.map((industry) => {
            const isActive = industry.id === selectedIndustryId;
            return (
              <button
                key={industry.id}
                type="button"
                role="tab"
                aria-selected={isActive}
                className={`testing-exercising-industry__chip${isActive ? ' is-active' : ''}`}
                onClick={() => onSelectIndustry(industry.id)}
              >
                {industry.name}
              </button>
            );
          })}
        </div>
        <div className="testing-exercising-industry__handout">
          <div className="testing-exercising-industry__handout-label">Handout impact statement</div>
          <p>
            {selectedIndustry?.impactStatement ||
              'Industry-specific impacts are inserted automatically from RiskCoach.'}
          </p>
          {handoutPdf?.downloadUrl && handoutPdf.downloadUrl !== '#' ? (
            <Button
              type="primary"
              href={handoutPdf.downloadUrl}
              target="_blank"
              rel="noopener noreferrer"
              icon="download"
            >
              Download {selectedIndustry?.name || 'industry'} handout (PDF)
            </Button>
          ) : (
            <Button type="primary" icon="download" disabled={handoutPdf?.downloadUrl === '#'}>
              Download {selectedIndustry?.name || 'industry'} handout (PDF)
              {handoutPdf?.downloadUrl === '#' ? ' — coming soon' : ''}
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
}
